/**
 *
 * Add / Update Repository -> GitLab, Github, Bitbucket
 *
 */

import React from 'react';

import { AccountType } from '@ariksa/cloud-account';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { AddRepositoryForm } from 'containers/Setup/Integrations/Components/IntegrationsWizard/DataSources/Components/AddRepository/AddRepositoryForm';
import { useIntegrations } from 'containers/Setup/Integrations/hooks/useIntegrations';
import { selectSetup } from 'containers/Setup/selectors';

export const AddRepository = () => {
  const { onCancel, getAccounts } = useIntegrations();
  const { activeAccount } = useSelector(selectSetup);

  const params = useParams<{
    provider: string;
    id: string;
  }>();

  return (
    <>
      <AddRepositoryForm
        onCancel={onCancel}
        getAccounts={() => getAccounts(AccountType.Saas)}
        selectedProvider={params.provider!}
        actionType={params.id ? 'Update' : 'Add'}
        accountDetails={activeAccount.data}
      />
    </>
  );
};
